import ServiceBrand from '../../../components/public/ServiceBrand';
import GeneratedByFooter from '../../../components/public/GeneratedByFooter';

/** Minimal chrome for unauthenticated signer pages. */
export default function PublicShell({ title, subtitle, children }) {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-700">
      <header className="border-b border-slate-200 bg-slate-100 px-6 py-4">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center gap-x-5 gap-y-2">
          <ServiceBrand module="sign" />
          <div className="min-w-0 border-slate-300 sm:border-l sm:pl-5">
            <h1 className="truncate text-base font-semibold text-slate-900">
              {title ?? 'MyDocUploads'}
            </h1>
            {subtitle && <p className="truncate text-xs text-slate-500">{subtitle}</p>}
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-6">{children}</main>
      <div className="mx-auto w-full max-w-4xl px-4"><GeneratedByFooter /></div>
    </div>
  );
}
